<!-- Main Content Container -->
<div class="flex flex-col min-h-0 space-y-6">
    <!-- Page Header Section -->
    <section class="flex flex-col p-6 space-y-5 bg-white rounded shadow md:p-8">
        <div class="pb-4 border-b border-gray-200">
            <h1 class="text-2xl font-bold text-gray-800 md:text-3xl">Profile Listing - {{ type }}</h1>
        </div>

        <!-- Search and Controls Section -->
        <div class="flex flex-col gap-4 mb-5 md:flex-row md:flex-wrap md:items-end">
            <!-- Search Input -->
            <div class="relative w-full md:w-[36rem] md:max-w-full md:shrink-0">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <lucide-icon class="w-5 h-5 text-gray-500" [img]="Search"></lucide-icon>
                </div>
                <app-input
                    type="search"
                    id="search"
                    class="w-full"
                    [inputClass]="
                        'w-full border-2 border-primary pl-10 py-2 pr-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200'
                    "
                    placeholder="Search by investor name, investee code, public profile keywords"
                    [value]="search"
                    (input)="onSearchChange($event)"
                >
                </app-input>
            </div>

            <div class="flex flex-col w-full md:w-56 md:shrink-0">
                <label for="lastUpdated" class="block mb-1 text-sm font-medium text-gray-700">
                    Profile Last Updated
                </label>
                <app-date-picker
                    id="lastUpdated"
                    [(ngModel)]="lastUpdated"
                    (ngModelChange)="onDateChange()"
                    format="MM/dd/yyyy"
                    placeholder="mm/dd/yyyy"
                ></app-date-picker>
            </div>

            <div class="flex flex-col w-full md:w-56 md:shrink-0">
                <label for="recordCount" class="block mb-1 text-sm font-medium text-gray-700">
                    Number of records to display
                </label>
                <app-input
                    type="number"
                    id="recordCount"
                    class="w-full"
                    [inputClass]="'input input--primary w-full'"
                    [(ngModel)]="recordCount"
                    (change)="onRecordChange()"
                ></app-input>
            </div>

            <div class="w-full md:w-auto md:shrink-0">
                <app-button
                    type="button"
                    class="w-full md:w-auto"
                    [icon]="RefreshCcw"
                    btnClass="w-full md:w-auto button button--primary transition font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center hover:shadow-md whitespace-nowrap"
                    label="Reset Filter"
                    (click)="clearFilters()"
                ></app-button>
            </div>
        </div>

        <div class="overflow-x-auto rounded-lg">
                <div class="hidden md:block">
                    <table class="min-w-full border border-gray-200 rounded-lg shadow-sm">
                        <thead class="text-white bg-primary">
                            <tr>
                                <th class="px-4 py-2 text-left">Total {{ type }}s</th>
                                <th class="px-4 py-2 text-left">Pinned</th>
                                <th class="px-4 py-2 text-left">Online</th>
                                <th class="px-4 py-2 text-left">Connections</th>
                            </tr>
                        </thead>
                        <tbody class="text-gray-800">
                            @if (loading) {
                                <tr class="bg-white">
                                    <td colspan="4" class="px-4 py-4 border-t">
                                        <div class="flex items-center justify-center">
                                            <lucide-icon [img]="Loader" class="w-8 h-8 text-primary animate-spin" />
                                        </div>
                                    </td>
                                </tr>
                            } @else {
                                <tr class="bg-white">
                                    <td class="px-4 py-2 border-t">{{ total }}</td>
                                    <td class="px-4 py-2 border-t">{{ pinned }}</td>
                                    <td class="px-4 py-2 border-t">{{ onlineUsers.size }}</td>
                                    <td class="px-4 py-2 border-t">{{ connections }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div class="space-y-4 md:hidden">
                    <table class="w-full border border-gray-200 rounded-lg shadow-sm">
                        <thead class="text-white bg-primary">
                            <tr>
                                <th class="w-1/2 px-4 py-2 text-left">Total {{ type }}s</th>
                                <th class="px-4 py-2 text-left">Pinned</th>
                            </tr>
                        </thead>
                        <tbody class="text-gray-800">
                            @if (loading) {
                                <tr class="bg-white">
                                    <td colspan="2" class="px-4 py-4 border-t">
                                        <div class="flex items-center justify-center">
                                            <lucide-icon [img]="Loader" class="w-8 h-8 text-primary animate-spin" />
                                        </div>
                                    </td>
                                </tr>
                            } @else {
                                <tr class="bg-white">
                                    <td class="w-1/2 px-4 py-2 border-t">{{ total }}</td>
                                    <td class="px-4 py-2 border-t">{{ pinned }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>

                    <table class="w-full border border-gray-200 rounded-lg shadow-sm">
                        <thead class="text-white bg-primary">
                            <tr>
                                <th class="w-1/2 px-4 py-2 text-left">Online</th>
                                <th class="px-4 py-2 text-left">Connections</th>
                            </tr>
                        </thead>
                        <tbody class="text-gray-800">
                            @if (loading) {
                                <tr class="bg-white">
                                    <td colspan="2" class="px-4 py-4 border-t">
                                        <div class="flex items-center justify-center">
                                            <lucide-icon [img]="Loader" class="w-8 h-8 text-primary animate-spin" />
                                        </div>
                                    </td>
                                </tr>
                            } @else {
                                <tr class="bg-white">
                                    <td class="w-1/2 px-4 py-2 border-t">{{ onlineUsers.size }}</td>
                                    <td class="px-4 py-2 border-t">{{ connections }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
    </section>

    <!-- Table Section -->
    <section class="bg-white rounded shadow list-table-section">
        <div class="p-2 table-container md:p-6">
            <app-data-table
                [columns]="columns"
                [data]="allUsers"
                [meta]="meta"
                [rowActions]="actions"
                [page]="page"
                [loading]="loading"
                [error]="null"
                [showPageInput]="false"
                [stickyHeader]="true"
                style="--sticky-header-top: -24px"
                (rowAction)="onRowAction($event)"
                (pageChange)="onPageChange($event)"
                class="w-full"
            >
            </app-data-table>
        </div>
    </section>
</div>

<ng-template
    #reportModal
    let-description="description"
    let-currentRow="currentRow"
    let-onSubmit="onSubmit"
    let-onCancel="onCancel"
>
    <div class="w-full max-w-xl">
        <form [formGroup]="reportForm" class="space-y-6">
            <!-- Multi-select Terms Condition -->
            <div class="form-group">
                <label for="violations" class="block mb-2 text-sm font-medium text-gray-700">
                    Please select the violated Terms and Conditions *
                </label>
                <div class="relative">
                    <app-combo-box
                        [options]="violations"
                        formControlName="violations"
                        placeholder="Select violated Terms and Conditions"
                        [multiSelect]="true"
                        [searchable]="false"
                        [clearable]="false"
                        [showError]="isFieldInvalid('violations')"
                    >
                    </app-combo-box>
                </div>
                @if (isFieldInvalid("violations")) {
                    <div class="flex items-center mt-1 text-xs text-red-600">
                        <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                        {{ getFieldError("violations") }}
                    </div>
                }
            </div>

            <!-- Others Field -->
            <div class="form-group">
                <label for="violations_others" class="block mb-2 text-sm font-medium text-gray-700"> Others </label>
                <div class="relative">
                    <textarea
                        id="violations_others"
                        formControlName="violations_others"
                        placeholder="Additional info"
                        class="input input--primary"
                        [class.input--error]="isFieldInvalid('violations_others')"
                        (keydown)="!isGeneralViolationSelected ? $event.preventDefault() : null"
                        (paste)="!isGeneralViolationSelected ? $event.preventDefault() : null"
                        [class.bg-gray-100]="!isGeneralViolationSelected"
                        [readonly]="!isGeneralViolationSelected"
                        [class.cursor-not-allowed]="!isGeneralViolationSelected"
                    ></textarea>
                </div>
                @if (isFieldInvalid("violations_others")) {
                    <div class="flex items-center mt-1 text-xs text-red-600">
                        <lucide-icon class="w-4 h-4 mr-2" [img]="CircleAlert"></lucide-icon>
                        {{ getFieldError("violations_others") }}
                    </div>
                }
            </div>

            <!-- Supporting Documents -->
            <div class="form-group">
                <label class="block mb-2 text-sm font-medium text-gray-700"> Attach Supporting Documents * </label>
                <app-file-upload
                    [acceptedTypes]="'image/*,.pdf,.doc,.docx'"
                    [maxFileSize]="5242880"
                    [maxFiles]="5"
                    [multiple]="true"
                    [showImageThumbnails]="true"
                    placeholder="Attach supporting documents (PDF, DOC, DOCX, Images) - Required"
                    subText="Max file size: 5MB per file. Minimum 1, maximum 5 files required."
                    (filesSelected)="onFileSelected($event)"
                    (fileRemoved)="onFileRemoved($event)"
                    (validationError)="onFileValidationError($event)"
                ></app-file-upload>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-col gap-3 pt-6 border-t border-gray-200 sm:flex-row sm:justify-end sm:gap-4">
                <app-button
                    type="button"
                    class="w-md sm:w-auto"
                    label="Cancel"
                    btnClass="border rounded-lg border-gray-300 font-semibold text-md px-6 py-2 w-full sm:w-auto hover:bg-gray-100"
                    (click)="onCancel()"
                ></app-button>
                <app-button
                    type="button"
                    class="w-md sm:w-auto"
                    label="Submit"
                    loadingText="Submitting..."
                    [isLoading]="loading"
                    [disabled]="!violationsLoaded"
                    (click)="onSubmit()"
                    btnClass="button button--primary transition font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center flex items-center justify-center"
                ></app-button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #modalTemplate let-onConfirm="onConfirm" let-onCancel="onCancel">
    <div class="w-full max-w-md">
        <p class="mb-6 text-gray-700">Are you sure you want to proceed?</p>
        <div class="flex justify-end space-x-2">
            <button
                type="button"
                class="px-5 py-2.5 text-sm font-semibold text-primary border border-primary rounded hover:bg-gray-100"
                (click)="onCancel()"
                [disabled]="loading"
            >
                No
            </button>
            <app-button
                type="button"
                label="Yes"
                btnClass="px-5 py-2.5 text-sm font-semibold text-white bg-tertiary border border-transparent rounded hover:bg-tertiary-80 flex items-center justify-center"
                [disabled]="loading"
                [isLoading]="isSubmitted"
                (click)="onConfirm()"
            ></app-button>
        </div>
    </div>
</ng-template>
